import { tv } from "@fanka/tailwind-variants";

export const LEGEND_CELL_CLASS_NAME = tv({
  base: "flex border-r z-[320] border-grayScale-200  bg-base-0 relative justify-end pr-2 items-center",
  variants: {
    isBold: {
      true: "text-ui14",
      false: "text-ui12",
    },
  },
  defaultVariants: {
    isBold: false,
  },
});
